require('./files/paginator');
require('./files/review-images');
require('./files/popup-review-carousel.js');

require('../../css/web/reviews.css');
require('../../sass/web/reviews-images.scss');
require('../../css/web/paginator.css');